import { render, staticRenderFns } from "./channelClassification.vue?vue&type=template&id=1efdda1b&scoped=true&"
import script from "./channelClassification.vue?vue&type=script&lang=js&"
export * from "./channelClassification.vue?vue&type=script&lang=js&"
import style0 from "./channelClassification.vue?vue&type=style&index=0&id=1efdda1b&prod&scoped=true&lang=css&"
import style1 from "./channelClassification.vue?vue&type=style&index=1&id=1efdda1b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efdda1b",
  null
  
)

export default component.exports